var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Form', {
    attrs: {
      "url": "/nfe/create",
      "venda": _vm.venda
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };